export const tagFunctions = {
  compileTags(restaurants){
    if(restaurants){
      var tagsList = restaurants.map(this.tagLister);
      var tagsList2 = restaurants.map(this.tagLister2);
      tagsList.push(tagsList2)
      let fullTags = [...new Set(tagsList.flat(1))];
      const index = fullTags.indexOf('');
      if (index > -1) {
        fullTags.splice(index, 1);
      }
    let array = fullTags.map(this.tagCompiler);
    return(array)
    }
  },

  compilePrimaryTags(restaurants){
    if(restaurants){
      var tagsList = [];
      var tagsList2 = restaurants.map(this.tagLister2);
      tagsList.push(tagsList2)
      let fullTags = [...new Set(tagsList.flat(1))];
      const index = fullTags.indexOf('');
      if (index > -1) {
        fullTags.splice(index, 1);
      }
    let array = fullTags.map(this.tagCompiler);
    return(array)
    }
  },

  tagLister(restaurant){
    return restaurant['tags']
  },

  tagLister2(restaurant){
    return restaurant['primaryTag']
  },

  tagCompiler(tag){
    return({ value: tag, label: tag })
  }
}

export const isTagged = (project, tags) =>{
  var containsTags = false;
  for(let tag of tags) {
          if(project.tags && project.primaryTag && (project.tags.includes(tag['value']) || project.primaryTag === tag['value']) ){
            containsTags = true;
          }
          else{
            containsTags = false;
            break;
          }
        }
  return containsTags;
  }

export const isTaggedAny = (project, tags) =>{
  var containsTags = false;
  for(let tag of tags) {
          if(project.tags && (project.tags.includes(tag['value']) || project.primaryTag.includes(tag['value'])) ){
            containsTags = true;
            break;
          }
          else{
            containsTags = false;
          }
        }
  return containsTags;
  }
